import { MovieStreamFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getNotNullableItems } from '@/scenarios/legacy-player/lib/get-not-nullable-items';

import { transformSubtitles } from '../../movie-player/transformers/transform-subtitles';

export const getSportSubtitles = (stream: MovieStreamFragment | null) => {
    const subtitles = getNotNullableItems(stream?.streamMeta?.subtitleMetas);

    return transformSubtitles(subtitles);
};
